module.exports = __webpack_public_path__ + "static/img/icon_mini_btn_sel.8d5f513.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_mini_btn_sel.png
// module id = xTwt
// module chunks = 1